export const FULL_SCREEN_DIALOG_ID = 'fullscreen';
export const MASTERFIND_DIALOG_ID = 'masterfind';
